import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.69 8.667h30.647c.528 2.514.69 5.055.66 7.35a34 34 0 0 1-.687 7.316H.682c-.548-2.53-.709-5.063-.679-7.35-.03-2.257.158-4.786.687-7.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.338 8.667H.69q.083-.396.177-.792S1.895 2.957 6.343 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.691 1.263 4.447 1.728 5.476 6.646 5.476 6.646q.091.378.17.758M.682 23.333H31.31a30 30 0 0 1-.177.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124a26 26 0 0 1-.184-.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M13.794 12.519a.1.1 0 0 1-.038-.182l.946-.637a.091.091 0 0 0-.051-.167.091.091 0 0 1-.067-.152l1.17-1.285a.1.1 0 0 1 .153.007l.751 1.004a.1.1 0 0 0 .04.031l1.941.862a.1.1 0 0 1-.03.191l-.316.033a.1.1 0 0 0-.042.185l.817.5c.086.053.049.185-.052.185h-.973a.1.1 0 0 0-.057.183l2.34 1.613a.1.1 0 0 1-.051.182l-.767.048c-.107.006-.13.152-.032.192l1.192.489a.1.1 0 0 1-.017.19l-1.14.246c-.104.023-.105.172 0 .196l.507.116a.1.1 0 0 1 .044.023l1.15 1.024c.078.07.008.198-.093.17l-.876-.235a.1.1 0 0 0-.086.016l-.331.247a.1.1 0 0 0 .003.162l2.14 1.465a.1.1 0 0 1 .028.135l-.128.208a.1.1 0 0 1-.132.036l-1.382-.73a.1.1 0 0 0-.045-.012l-1.465-.034-.027-.005-1.333-.406a.1.1 0 0 0-.128.084l-.167 1.488a.1.1 0 0 0 .027.08l1.496 1.57a.1.1 0 0 1-.049.165l-.173.043a.1.1 0 0 1-.097-.028l-.558-.589a.1.1 0 0 0-.054-.03l-.81-.148a.1.1 0 0 0-.115.127l.047.155a.1.1 0 0 1-.154.11l-.778-.549a.1.1 0 0 1-.038-.052l-.076-.25a.1.1 0 0 0-.103-.071l-1.034.082a.1.1 0 0 0-.047.016l-.838.548a.1.1 0 0 1-.03.013l-.906.224a.1.1 0 0 0-.038.018l-.42.331a.1.1 0 0 1-.025.014.083.083 0 0 1-.09-.132l.267-.317a.1.1 0 0 1 .03-.024l1.071-.576a.1.1 0 0 0 .04-.038l.764-1.33a.1.1 0 0 0-.022-.126l-.647-.552a.1.1 0 0 0-.1-.017c-.355.136-2.3.881-2.341.89-.029.005-.335-.105-.553-.185a.099.099 0 0 1-.008-.183l2.006-.956a.1.1 0 0 0 .005-.178l-.296-.16a.1.1 0 0 0-.092-.003l-1.512.74a.1.1 0 0 1-.06.009l-.666-.112a.1.1 0 0 1-.04-.18l2.256-1.56a.1.1 0 0 0 .034-.123l-.188-.416a.1.1 0 0 0-.142-.045l-.85.508a.1.1 0 0 1-.096.004l-.235-.117a.1.1 0 0 1-.016-.169l2.165-1.665a.1.1 0 0 0 .034-.11l-.101-.312a.1.1 0 0 0-.095-.07h-.844a.1.1 0 0 1-.057-.182l1.984-1.377a.1.1 0 0 0 .042-.073l.016-.163a.1.1 0 0 0-.082-.108z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagLbn = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagLbn_default = SvgFlagLbn;

export { FlagLbn_default as default };
